<template>
  <v-card height="100%">
    <v-card-title>{{ $t("paymentMethods") }}</v-card-title>
    <v-card-text class="px-0">
      <v-progress-circular
        v-if="loading"
        class="my-4 mx-auto d-block"
        indeterminate
        color="primary"
        :size="50"
        :width="7"
      ></v-progress-circular>
      <pie-chart
        v-else-if="chartData.length"
        :height="300"
        :chartdata="pieChartData"
        :options="pieChartOptions"
      ></pie-chart>
      <p v-else class="text-body-1 text-center">{{ $t("noDataFound") }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { getCurrencySign } from "@/static/currencies";
import PieChart from "@/components/charts/PieChart.js";

const defaultChartData = {
  labels: [],
  datasets: [
    {
      backgroundColor: [
        "#FDB929",
        "#FF943A",
        "#FF7051",
        "#EF5267",
        "#D23E7A",
        "#A93788",
        "#78388D",
        "#3A3888",
      ],
      data: [],
    },
  ],
};

export default {
  name: "PaymentMethodsTotalsChart",
  components: {
    PieChart,
  },
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    chartData: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      pieChartData: null,
      pieChartOptions: {
        title: {
          display: false,
        },
        tooltips: {
          yPadding: 8,
          xPadding: 8,
          borderColor: "#ffffff",
          borderWidth: 1,
          caretSize: 8,
          displayColors: false,
          callbacks: {
            label: (item, data) => {
              const label = [
                data.labels[item.index],
                this.currencySign +
                  " " +
                  parseFloat(data.datasets[0].data[item.index])
                    .toFixed(2)
                    .toString(),
              ];
              return label;
            },
          },
        },
      },
    };
  },
  computed: {
    currencySign() {
      let sign = "";
      const currencySign = getCurrencySign(this.currentHotel.currencyCode);
      if (currencySign) {
        sign = currencySign;
      }
      return sign;
    },
    ...mapState(["currentHotel"]),
  },
  watch: {
    chartData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.createChart(val);
      },
    },
  },
  methods: {
    createChart(data) {
      const chatData = defaultChartData;
      chatData.labels = data.map((item) => item.name);
      //chatData.counts = data.map((item) => item.counts);
      chatData.datasets[0].data = data.map((item) => item.amount);
      this.pieChartData = chatData;
    },
  },
};
</script>
